import { createBaseApi } from '../baseApi';
import { API_ENDPOINTS } from '../../../utils/config';

const sharedProfileApi = createBaseApi('sharedProfileApi');

export const enhancedSharedProfileApi = sharedProfileApi.injectEndpoints({
  endpoints: (builder) => ({
    getPublicProfile: builder.query({
      queryFn: async (username, _queryApi, _extraOptions, fetchWithBQ) => {
        // Try Strapi backend first
        const result = await fetchWithBQ({
          url: API_ENDPOINTS.SHARED_CLOSET.USER_PROFILE(username),
          method: 'GET'
        });
        
        if (result.data) {
          return { data: result.data };
        }

        // Fallback: Fetch from Marketing Hub for the marketing campaign
        try {
          const mktResponse = await fetch(`http://localhost:4200/api/share-links/profile/${username}`);
          if (mktResponse.ok) {
            const data = await mktResponse.json();
            return { data };
          }
        } catch (e) {
          console.warn('Marketing hub fallback failed:', e);
        }

        return { error: result.error || { status: 404, data: 'Not found' } };
      },
      providesTags: ['SharedCloset', 'User'],
      transformResponse: (response) => response
    })
  })
});

export const { useGetPublicProfileQuery } = enhancedSharedProfileApi;
export default enhancedSharedProfileApi;
